module.exports = __webpack_public_path__ + "assets/edit.3b2575a4.svg";